import React from "react";

export default function PageIntro({ title, subtitle, text }) {
  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold uppercase mb-4">{title}</h2>
      <p className="text-lg text-gray mb-6">{subtitle}</p>
      <hr className="w-2/5 lg:w-1/5 border-red mb-8 mx-auto" />
      <p className="text-gray md:px-4">{text}</p>
    </div>
  );
}
